





























































import { Component, Vue, Prop } from 'vue-property-decorator';
import QuestionContainer from '@/components/questions/QuestionContainer.vue';
import {
  BuildObjectiveQuestion,
  BuildSubjectiveQuestion,
} from '@/utils/add-question/add-question-util';
import { QuestionLanguage } from '@/resource/subject/subject.model';
import { randomizeObjAnswerPosition } from './new-editor.util';

@Component({
  components: { QuestionContainer },
})
export default class EditorPreview extends Vue {
  @Prop({ required: true })
  buildSubjectiveQuestion: BuildSubjectiveQuestion;

  @Prop({ required: true })
  buildObjectiveQuestion: BuildObjectiveQuestion;

  @Prop({ required: true })
  languages: QuestionLanguage[];

  @Prop({ required: true })
  isSubjective!: boolean;

  @Prop({ required: true })
  isAdmin!: boolean;

  get answerPosition() {
    return randomizeObjAnswerPosition(this.question as any, this.isSubjective);
  }

  get question() {
    if (this.isSubjective) {
      return this.buildSubjectiveQuestion;
    } else {
      return this.buildObjectiveQuestion;
    }
  }
}
